import { Page } from '@/constant/routes';

export interface RouteConfig {
  path: string;
  exact?: boolean;
  page: string;
  redirect?: string;
  name?: string;
}

const routes: RouteConfig[] = [
  {
    path: '/home',
    exact: true,
    page: Page.Home,
    name: Page.Home,
  },
  {
    path: '/hot-question',
    exact: true,
    page: Page.HotQuestion,
    name: Page.HotQuestion,
  },
  {
    path: '/search',
    exact: true,
    page: Page.Search,
    name: Page.Search,
  },
  {
    path: '/category/:id',
    exact: true,
    page: Page.Category,
    name: Page.Category,
  },
  {
    path: '/details/:id',
    exact: true,
    page: Page.Details,
    name: Page.Details,
  },
  {
    path: '/',
    page: 'Error',
    redirect: '/home',
  },
];

export default routes;
